/* BMC Landing OCARINA (Dan 2026-09-22). The cart-drawer half of bmc-landing-toby.js,
   minus the Toby A/B plumbing, so buying here can never stamp a Toby arm on an order.
   - Every a[href="#bmc-lp-buy"] adds the course through the Monster Upsell app's own
     drawer (window.monster_addToCart), which opens it, then injects the "start today"
     rows from #bmc-drawer-offer-data into #mu-checkout-container.
   - The cart gets attribute bmc_src = oot-presale, carried onto the order.
   - Rows can be limited by visitor country (Shopify's geolocation endpoint); the book
     ships to US, UK and Canada only.
   - sprintCode (LAUNCH51, Toby only, product scoped) is planted in the session once so
     the Toby row's price is what the cart charges.
   - Shipping Protection is dropped from an all-digital cart, as on the Toby page. */
(function () {
  var form = document.getElementById('bmc-lp-form');
  if (!form) return;

  var SRC = 'oot-presale';
  var SHIP_PROTECT = '45140585971862';
  var POST = { method: 'POST', credentials: 'same-origin',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' } };
  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); }

  var FUNNEL_VARIANTS = [];
  try {
    var zeroRaw = form.getAttribute('data-zero');
    if (zeroRaw) FUNNEL_VARIANTS = JSON.parse(zeroRaw).map(String).filter(function (v) { return v && v !== 'null' && v !== 'undefined'; });
  } catch (e) { FUNNEL_VARIANTS = []; }

  var offerCfg = null;
  try {
    var cfgEl = document.getElementById('bmc-drawer-offer-data');
    if (cfgEl) offerCfg = JSON.parse(cfgEl.textContent);
  } catch (e) {}

  function applySprintCode(code) {
    if (!code) return;
    var key = 'bmc_sprint_' + code;
    try { if (window.sessionStorage.getItem(key)) return; } catch (e) {}
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { credentials: 'same-origin' })
      .then(function () { try { window.sessionStorage.setItem(key, '1'); } catch (e) {} })
      .catch(function () {});
  }
  if (offerCfg && offerCfg.sprintCode) applySprintCode(offerCfg.sprintCode);

  function muAdd(items) {
    if (typeof window.monster_addToCart === 'function') {
      try { return Promise.resolve(window.monster_addToCart({ items: items })); } catch (e) {}
    }
    // App missing or broken: proven AJAX add, then the real cart page.
    var p = new URLSearchParams();
    items.forEach(function (it, i) {
      p.append('items[' + i + '][id]', it.id);
      p.append('items[' + i + '][quantity]', it.quantity);
    });
    return fetch('/cart/add.js', Object.assign({ body: p.toString() }, POST))
      .then(function () { window.location.href = '/cart'; });
  }
  function muRefresh() {
    if (typeof window.monster_refresh === 'function') {
      try { return Promise.resolve(window.monster_refresh()); } catch (e) {}
    }
    return Promise.resolve();
  }

  var offerBusy = false;

  function bumpRow(b) {
    var li = document.createElement('li');
    li.className = 'bmc-do__item';
    li.setAttribute('data-variant', b.variant);
    li.innerHTML =
      '<img class="bmc-do__img" width="44" height="44" loading="lazy">' +
      '<span class="bmc-do__copy"><span class="bmc-do__t"></span><span class="bmc-do__d"></span></span>' +
      '<button type="button" class="bmc-do__btn"></button>';
    li.querySelector('.bmc-do__t').textContent = b.title;
    // The first sentence of the blurb ("Instant access." / "Ships now.") is the point, so it is bold.
    var d = li.querySelector('.bmc-do__d');
    var m = String(b.blurb || '').match(/^([^.]+\.)\s*(.*)$/);
    if (m) { var strong = document.createElement('b'); strong.textContent = m[1]; d.appendChild(strong); d.appendChild(document.createTextNode(' ' + m[2])); }
    else d.textContent = b.blurb || '';
    var img = li.querySelector('.bmc-do__img');
    img.src = b.img; img.alt = b.title;
    li.querySelector('.bmc-do__btn').addEventListener('click', function () { toggleBump(b); });
    return li;
  }

  function buildOfferBlock() {
    var el = document.createElement('div');
    el.id = 'bmc-drawer-offer';
    var h = document.createElement('p');
    h.className = 'bmc-do__kicker';
    h.textContent = offerCfg.heading || 'Add to your order';
    var ul = document.createElement('ul');
    ul.className = 'bmc-do__list';
    offerCfg.bumps.forEach(function (b) { ul.appendChild(bumpRow(b)); });
    el.appendChild(h); el.appendChild(ul);
    return el;
  }

  var GEO_KEY = 'bmc_geo_country';
  var geoCountry = '';
  function visitorCountry() {
    try { var c = window.sessionStorage.getItem(GEO_KEY); if (c) return Promise.resolve(c === '??' ? '' : c); } catch (e) {}
    return fetch('/browsing_context_suggestions.json?source=geolocation_recommendation', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var code = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
        code = code ? String(code).toUpperCase() : '';
        try { window.sessionStorage.setItem(GEO_KEY, code || '??'); } catch (e) {}
        return code;
      })
      .catch(function () { return ''; });
  }
  function countryAllows(b) {
    if (!geoCountry) return true;
    if (b.showIfCountry && b.showIfCountry.length && b.showIfCountry.indexOf(geoCountry) < 0) return false;
    if (b.hideIfCountry && b.hideIfCountry.length && b.hideIfCountry.indexOf(geoCountry) >= 0) return false;
    return true;
  }
  function bumpTriggered(b, skus, vids) {
    var trig = b.showIfCartHas || [];
    if (!trig.length) return true;
    for (var i = 0; i < trig.length; i++) {
      var t = String(trig[i]);
      if (skus[t] || vids[t]) return true;
    }
    return false;
  }

  function paintBumps(cart) {
    var block = document.getElementById('bmc-drawer-offer');
    if (!block || !cart || !cart.items) return;
    var skus = {}, vids = {};
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.sku) skus[it.sku] = true;
      vids[String(it.variant_id)] = true;
    }
    var shown = 0;
    offerCfg.bumps.forEach(function (b) {
      var row = block.querySelector('.bmc-do__item[data-variant="' + b.variant + '"]');
      if (!row) return;
      var inCart = !!(vids[String(b.variant)] || (b.sku && skus[b.sku]));
      var show = inCart || (bumpTriggered(b, skus, vids) && countryAllows(b));
      row.hidden = !show;
      if (show) shown++;
      if (inCart) row.classList.add('is-on'); else row.classList.remove('is-on');
      var btn = row.querySelector('.bmc-do__btn');
      btn.textContent = inCart ? 'Added' : '+' + money(b.price) + (b.priceSuffix || '');
      btn.setAttribute('aria-label', (inCart ? 'Remove ' : 'Add ') + b.title);
    });
    block.hidden = shown === 0;
  }

  function refreshCartState() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) return cart;
        var ships = false, orphanProtect = false;
        for (var i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          if (String(it.variant_id) === SHIP_PROTECT) { orphanProtect = true; continue; }
          // LearnDash courses (SKU LD-<id>) never ship, whatever the variant flag says.
          if (it.requires_shipping && !/^LD-\d+$/.test(String(it.sku || ''))) ships = true;
        }
        var cl = document.documentElement.classList;
        if (ships) cl.add('bmc-cart-ships'); else cl.remove('bmc-cart-ships');
        if (offerCfg) paintBumps(cart);
        if (ships || !orphanProtect) return cart;
        var u = new URLSearchParams();
        u.append('updates[' + SHIP_PROTECT + ']', '0');
        return fetch('/cart/update.js', Object.assign({ body: u.toString() }, POST))
          .then(function (r) { return r.json(); })
          .catch(function () { return cart; });
      })
      .catch(function () { return null; });
  }

  function toggleBump(b) {
    if (offerBusy || !offerCfg) return;
    offerBusy = true;
    var block = document.getElementById('bmc-drawer-offer');
    var row = block && block.querySelector('.bmc-do__item[data-variant="' + b.variant + '"]');
    var btn = row && row.querySelector('.bmc-do__btn');
    var on = !!(row && row.classList.contains('is-on'));
    if (btn) btn.setAttribute('disabled', 'disabled');
    var after = function () {
      offerBusy = false;
      var again = document.querySelector('#bmc-drawer-offer .bmc-do__item[data-variant="' + b.variant + '"] .bmc-do__btn');
      if (again) again.removeAttribute('disabled');
    };
    if (on) {
      var u = new URLSearchParams();
      u.append('updates[' + b.variant + ']', '0');
      fetch('/cart/update.js', Object.assign({ body: u.toString() }, POST))
        .then(muRefresh).then(refreshCartState).catch(function () {}).then(after);
    } else {
      muAdd([{ id: Number(b.variant), quantity: 1 }])
        .then(refreshCartState).catch(function () {}).then(after);
    }
  }

  function placeOfferCard() {
    if (!offerCfg) return;
    var host = document.getElementById('mu-checkout-container');
    if (!host) return;
    var block = document.getElementById('bmc-drawer-offer');
    if (!block) block = buildOfferBlock();
    var ocu = document.getElementById('mu-ocu-container');
    var want = (ocu && ocu.parentElement === host) ? ocu : host.firstChild;
    if (block.parentElement !== host || block.nextSibling !== want) host.insertBefore(block, want);
  }

  if (offerCfg && window.MutationObserver) {
    var moPending = false, wasOpen = false, lastItemsFp = null;
    new MutationObserver(function () {
      if (moPending) return;
      moPending = true;
      setTimeout(function () {
        moPending = false;
        placeOfferCard();
        var open = !!document.querySelector('#monster-cart-wrapper.mu_openned');
        var itemsEl = document.getElementById('mu-items-container');
        var totalEl = document.getElementById('mu-checkout-button');
        var fp = ((itemsEl ? itemsEl.textContent : '') + '|' + (totalEl ? totalEl.textContent : '')).replace(/\s+/g, '');
        if (open && (!wasOpen || fp !== lastItemsFp)) {
          lastItemsFp = fp;
          refreshCartState();
        }
        wasOpen = open;
      }, 120);
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }
  placeOfferCard();
  refreshCartState();
  visitorCountry().then(function (c) { geoCountry = c || ''; return refreshCartState(); });

  // Every #bmc-lp-buy button: clear only this course (no duplicates), stamp the source,
  // then add it through the app so its drawer opens with the rows in it.
  var buying = false;
  function drawerBuy(e) {
    if (e) { e.preventDefault(); e.stopImmediatePropagation(); }
    if (buying) return;
    buying = true;
    var mainInput = form.querySelector('input[name="items[0][id]"]');
    var mainId = mainInput ? mainInput.value : null;
    if (!mainId) { buying = false; return; }
    var hit = (e && e.target && e.target.closest) ? e.target.closest('a[href="#bmc-lp-buy"]') : null;
    var hitLabel = hit ? hit.innerHTML : null;
    if (hit) { hit.setAttribute('aria-busy', 'true'); hit.style.pointerEvents = 'none'; hit.textContent = 'Adding to cart...'; }
    var restore = function () {
      if (hit && hitLabel !== null) { hit.innerHTML = hitLabel; hit.removeAttribute('aria-busy'); hit.style.pointerEvents = ''; }
    };
    var clr = new URLSearchParams();
    FUNNEL_VARIANTS.forEach(function (id) { clr.append('updates[' + id + ']', '0'); });
    clr.append('attributes[bmc_src]', SRC);
    fetch('/cart/update.js', Object.assign({ body: clr.toString() }, POST))
      .then(function () { return muAdd([{ id: Number(mainId), quantity: 1 }]); })
      .then(function () { placeOfferCard(); return refreshCartState(); })
      .catch(function () { window.location.href = '/cart'; })
      .then(function () { buying = false; restore(); });
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var a = t && t.closest ? t.closest('a[href="#bmc-lp-buy"]') : null;
    if (!a) return;
    drawerBuy(e);
  }, true);

  // Block the store's 10% / email popups on this page (never touches our own UI).
  function hidePopupRoot(el) {
    var top = el, hop = 0;
    while (top.parentElement && hop < 6) { var ps = getComputedStyle(top.parentElement); if (ps.position === 'fixed' || ps.position === 'absolute') top = top.parentElement; hop++; }
    if (top.closest && (top.closest('.oot') || top.closest('.oot-bar'))) return;
    top.style.setProperty('display', 'none', 'important');
  }
  function killPromoPopups() {
    try {
      var known = document.querySelectorAll('[class*="klaviyo-form"],[class*="kl-private-reset"],[class*="kl-teaser"],[id^="klaviyo"]');
      for (var i = 0; i < known.length; i++) { if (!known[i].closest('.oot')) known[i].style.setProperty('display', 'none', 'important'); }
      var all = document.querySelectorAll('div,section,aside,dialog,form');
      for (var k = 0; k < all.length; k++) {
        var el = all[k], st = getComputedStyle(el);
        if (st.position !== 'fixed' && st.position !== 'absolute') continue;
        if ((parseInt(st.zIndex, 10) || 0) < 50) continue;
        if (el.closest('.oot') || el.closest('.oot-bar') || el.offsetHeight < 60) continue;
        if (/10\s*%|10\s*percent/i.test(el.textContent || '')) hidePopupRoot(el);
      }
    } catch (e) {}
  }
  killPromoPopups();
  var kpN = 0, kpTimer = setInterval(function () { killPromoPopups(); if (++kpN > 45) clearInterval(kpTimer); }, 800);
})();
